module.exports = {
  input: {
    decimal: 2,
    write_default: '',
    write_max: 16,
    write_min: 0,
    write_type: 10,
    formula: '',
    is_unique: 0,  // 是否唯一
    min_limit: '',  // 最小值限制
    max_limit: ''   // 最大值限制
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/text.js